export const parseDashboardNames = (name: string) => {
  let splitName = name.split("-");
  if (splitName.length > 1) {
    splitName.shift();
    return splitName.join("-").trim();
  } else {
    return splitName[0];
  }
};
